import { HttpClient, HttpContext, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { HANDLE_ERROR_AND_THROW } from '@helios/utils'
import { Observable, throwError } from 'rxjs'
import { FlexPositionsExportRequest } from '../models/flex-positions-export.model'
import { SourceKey } from '../models/source-key.model'
import { QUERY_SOURCE } from './http-workbench-data-source'
import { PositionsExportService } from './positions-export.service'

/**
 * The server-side XLSX export (PVAL-26419, helios MR !497). Same `helios-flex-positions` proxy
 * prefix as {@link QUERY_URL}, and the same `?source=` query parameter — the backend parses it with
 * the route's existing `parseSource`, so an unknown value is a 400.
 *
 * NOTE: !497 was still a Draft when this was written. Until it is deployed every export resolves to
 * the component's error toast; nothing else in the grid depends on it.
 */
export const EXPORT_URL = 'helios-flex-positions/flex-positions/export'

@Injectable()
export class HttpPositionsExportService extends PositionsExportService {
  constructor(private readonly http: HttpClient) {
    super()
  }

  exportToExcel(
    source: SourceKey,
    request: FlexPositionsExportRequest,
  ): Observable<Blob> {
    const querySource = QUERY_SOURCE[source]
    if (!querySource) {
      return throwError(
        () => new Error(`No export endpoint for source '${source}'`),
      )
    }

    return this.http.post(EXPORT_URL, request, {
      params: new HttpParams().set('source', querySource),
      responseType: 'blob',
      // Throw the failure to the caller rather than letting the app-wide ErrorInterceptor swallow it
      // into EMPTY: the grid owns the user-facing error toast, and a swallowed failure would never
      // reach it (and would leave the in-flight guard set forever).
      context: new HttpContext().set(HANDLE_ERROR_AND_THROW, true),
    })
  }
}
